import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NotificationComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
  ) {}

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected continue() {
    this.dialogRef.close(true);
  }
}
